export default __webpack_public_path__ + "static/media/Laughter.98461971.png";